import { ThemeProvider } from "@mui/system";
// import { theme } from "./Customization/Theme";
import RootNavigator from "./Routes/RootNavigator";
import { Provider } from "react-redux";
import CustomSnackbarProvider from "./Hooks/useNotification/CustomSnackbarProvider";
import store from "./Store";
import { useAppSelector } from "./Store";
import { useAuthStore } from "./Store/Slices/AuthSlice";
import { createDynamicTheme } from "./Customization/DynamicTheme";
import { validateToken } from "./Utils/Utils";
import TestApp from "./ThemedApp";
import ThemedApp from "./ThemedApp";
import { useEffect, useState } from "react";
import AppButton from "./AppComponents/AppButton";
import { theme } from "./Customization/Theme";
import useVersionCheck from "./Hooks/useVersionCheck";
import styled from "styled-components";
import { AnimationStyles, ButtonContainer, CancelButton, ContentWrapper, IconCircle, Overlay, TextContainer, TitleText, UpdateButton, VersionPopupContainer, VersionText } from  "./Utils/VersionPopupStyles";
validateToken();

interface AnimatedUpdateNotificationProps {
  isUpdateAvailable: any;
  currentVersion: any;
  latestVersion: any;
  updateApp: () => any;
  dismissPopup: any
}

const AnimatedUpdateNotification: React.FC<AnimatedUpdateNotificationProps> = ({ isUpdateAvailable, currentVersion, latestVersion, updateApp, dismissPopup }) => {
  const [animationState, setAnimationState] = useState('hidden');
  const [dismissed, setDismissed] = useState(false); 
  const { userConfig } = useAppSelector(useAuthStore);

  useEffect(() => {
    if (isUpdateAvailable) {
      setAnimationState("entering");
      const timer = setTimeout(() => {
        setAnimationState("stable");
      }, 2000);
      return () => clearTimeout(timer);
    } else {
      setAnimationState("hidden");
    }
  }, [isUpdateAvailable]);
  
  // Hiding the version update popup when these conditions occurs......
  if (animationState === "hidden") return null;

  return (
    <>
      <Overlay animationState={animationState} />
      <VersionPopupContainer animationState={animationState}>
        <ContentWrapper>
          <IconCircle>
            🎉
          </IconCircle>

          <TextContainer>
            <TitleText>
              A new version is available!
            </TitleText>
            <VersionText>
              Current: {currentVersion} → Latest: {latestVersion}
            </VersionText>
          </TextContainer>
        </ContentWrapper>

        <ButtonContainer>
          <CancelButton onClick={dismissPopup}>
            Cancel
          </CancelButton>
          <UpdateButton onClick={updateApp}>
            Update Now
          </UpdateButton>
        </ButtonContainer>
      </VersionPopupContainer>

      <AnimationStyles/>
    </>
  );
};

const AppContent = () => {
  const { userConfig } = useAppSelector(useAuthStore);
  const isAuthenticated = userConfig !== null;
  const { isUpdateAvailable, updateApp, dismissPopup, currentVersion, latestVersion } : any = useVersionCheck(isAuthenticated);
  
  return (
    <ThemeProvider theme={theme}>
      {isAuthenticated && (
      <AnimatedUpdateNotification
        isUpdateAvailable={isUpdateAvailable}
        currentVersion={currentVersion}
        latestVersion={latestVersion}
        updateApp={updateApp}
        dismissPopup={dismissPopup}
      />
      )}
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <ThemedApp />
      <AppContent />
    </Provider>
  );
};

export default App;